import { Image } from "@heroui/react";

export default function About() {
  return (
    <section className="relative z-20 bg-transparent mt-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 pt-20 md:pt-24">
        {/* Arriba: imagen a la izquierda, texto a la derecha */}
        <div className="flex flex-col md:flex-row items-start gap-6 md:gap-10">
          {/* Columna imagen: 50% en md+ */}
          <div className="w-full md:w-1/3 flex-shrink-0">
            <Image
              src="./vegan/equipo/k&p.webp"
              alt="Equipo Vegan Vegetarian"
              radius="sm"
              className="w-full h-auto object-contain mt-6"
            />
          </div>

          {/* Columna texto: 50% en md+ */}
          <div className="w-full md:w-2/3 flex flex-col gap-4 md:gap-6">
            {/* Encabezados alineados (centro en móvil, izquierda en desktop) */}
            <h4 className="text-primary font-semibold place-self-center">
              Karla & Pedro
            </h4>
            <h6 className="text-[#C5A537] place-self-center">
              Fundadores y chefs
            </h6>

            {/* Párrafos justificados */}
            <p className="text-black text-justify font-medium text-sm sm:text-base leading-relaxed">
              Karla y Pedro son los fundadores de Vegan Vegetarian, una marca nacida de la pasión, la disciplina y más de 30 años de experiencia en el mundo vegetariano.

              Su camino comenzó desde sus prácticas personales: Karla como maestra de yoga y Pedro como maestro de kung fu. Estas disciplinas no solo fortalecieron su mente y cuerpo, también los acercaron a un estilo de vida vegetariano consciente y sostenible.
            </p>
                     <p className="text-black text-justify font-medium text-sm sm:text-base leading-relaxed">
            Durante décadas, trabajaron en diversos restaurantes donde perfeccionaron sus habilidades culinarias. Su formación les permitió dominar distintos tipos de comidas, perfeccionando sus tecnicas y paladares. Gracias a todo ese proceso y la resiliencia de ambos nace Vegan Vegetarian.
            
            </p>
            
          </div>
        </div>

        {/* Debajo: párrafos a ancho completo con separación uniforme */}
        <div className="mt-8 md:mt-12 space-y-6">
          <p className="text-black text-justify font-medium text-sm sm:text-base leading-relaxed">
            Durante décadas, trabajaron en diversos restaurantes donde perfeccionaron sus habilidades culinarias. Su formación les permitió dominar desde la cocina tradicional regional, hasta la gastronomía india, mediterránea y la alta cocina vegetariana. En ese proceso fueron creando recetas propias, que hoy se han convertido en el corazón de Vegan Vegetarian.
          </p>

          <p className="text-black text-justify font-medium text-sm sm:text-base leading-relaxed">
            La filosofía que guía el proyecto es simple pero poderosa: “se puede comer sano y rico”. Ante la idea de que la comida vegetariana carece de sabor, Karla y Pedro demostraron lo contrario: todo está en el arte de cocinar. Así nació su misión de llevar a cada hogar platillos saludables y deliciosos, sin sacrificar lo más importante: el sabor.
          </p>

          <p className="text-black text-justify font-medium text-sm sm:text-base leading-relaxed">
            Como madre de dos hijos, Karla encontró en este estilo de vida una manera de darles una mejor calidad de vida, y al lograrlo, decidió compartir con el mundo que una alimentación vegetariana puede ser saludable, sostenible y profundamente sabrosa.
          </p>

          <p className="text-black text-justify font-medium text-sm sm:text-base leading-relaxed">
            El emprendimiento comenzó con platillos caseros, evolucionó hacia productos originales, y gracias a su participación en movimientos como Slow Food, mercados y tiendas orgánicas, hoy forman parte de Riqueza Local. La historia de Vegan Vegetarian es la historia de la resiliencia, el carisma y el buen corazón de Karla y Pedro. Una marca que busca llevar a la mesa de cada familia lo mejor de la comida vegetariana: salud, sabor y conciencia.
          </p>
        </div>

        <div className="pb-12 md:pb-16" />
      </div>
    </section>
  );
}
